function recommendation(backendAxiosInstance) {
  async function getMyList() {
    return backendAxiosInstance.get("/experiences/v3/recommendation/mylist", {
      includeDeviceType: true
    });
  }
  async function removeFromMyList({ id, type }) {
    return backendAxiosInstance.delete(`/experiences/v3/recommendation/mylist/${id}`, { params: { type }, data: {} });
  }
  async function addToMyList(addToMyListParams) {
    return backendAxiosInstance.post("/experiences/v3/recommendation/mylist", addToMyListParams);
  }
  async function getContinueWatchingShow(showId) {
    return backendAxiosInstance.get(`/experiences/v3/recommendation/continuewatching/show/${showId}`, {
      includeTimeZone: true
    });
  }
  async function getContinueWatchingMovie({ vmsId }) {
    return backendAxiosInstance.get(`/experiences/v3/recommendation/continuewatching/movie/${vmsId}`, {
      includeTimeZone: true
    });
  }
  async function getMoreLikeThis({
    vmsId,
    contentSourceType
  }) {
    return backendAxiosInstance.get(
      "/experiences/v3/recommendation/morelikethis",
      {
        params: { id: vmsId, contentSourceId: contentSourceType },
        includeTimeZone: true
      }
    );
  }
  async function getMostWatchedChannels() {
    return backendAxiosInstance.get("/experiences/v3/recommendation/mostwatchedchannels", {
      includeTimeZone: true
    });
  }
  async function getRecentlyWatchedChannels() {
    return backendAxiosInstance.get("/experiences/v3/recommendation/recentlywatchedchannels", {
      includeDeviceType: true,
      includeTimeZone: true
    });
  }
  return {
    addToMyList,
    getMyList,
    removeFromMyList,
    getContinueWatchingShow,
    getContinueWatchingMovie,
    getMoreLikeThis,
    getMostWatchedChannels,
    getRecentlyWatchedChannels
  };
}

export { recommendation as default };
//# sourceMappingURL=recommendation.js.map
